import {useSelector} from 'react-redux';
import {Typography} from '~library/atoms/Typography';

export const AttendeeCopy = (props) => {
  const {guest, label, dataQaId} = props;
  const allowKids = useSelector((state) => !!state.eventDetails.allowKids);

  const getAttendeeCopy = () => {
    if (label !== 'no') {
      let copy = '';
      if (guest.adults > 0) {
        copy += `${guest.adults} ${allowKids ? 'Adult' : 'Guest'}${guest.adults > 1 ? 's' : ''}`;
        if (allowKids && guest.kids > 0) {
          copy += ', ';
        }
      }
      if (allowKids && guest.kids > 0) {
        copy += `${guest.kids} Kid${guest.kids > 1 ? 's' : ''}`;
      }
      return copy;
    }
    return null;
  };

  return (
    <Typography variant="paragraph3" data-qa-id={dataQaId} color="pebble">
      {getAttendeeCopy()}
    </Typography>
  );
};
